/* SET STATE */
export const SET_STATE_LABTESTSAMPLE = "SET_STATE_LABTESTSAMPLE"

/* LABTESTSAMPLES */
export const GET_LABTESTSAMPLES = "GET_LABTESTSAMPLES"
export const GET_LABTESTSAMPLES_SUCCESS = "GET_LABTESTSAMPLES_SUCCESS"
export const GET_LABTESTSAMPLES_FAIL = "GET_LABTESTSAMPLES_FAIL"

/* LABTESTSAMPLE */
export const GET_LABTESTSAMPLE = "GET_LABTESTSAMPLE"
export const GET_LABTESTSAMPLE_SUCCESS = "GET_LABTESTSAMPLE_SUCCESS"
export const GET_LABTESTSAMPLE_FAIL = "GET_LABTESTSAMPLE_FAIL"

/**
 * ADD LABTESTSAMPLE
 */
 export const ADD_NEW_LABTESTSAMPLE = "ADD_NEW_LABTESTSAMPLE"
 export const ADD_LABTESTSAMPLE_SUCCESS = "ADD_LABTESTSAMPLE_SUCCESS"
 export const ADD_LABTESTSAMPLE_FAIL = "ADD_LABTESTSAMPLE_FAIL"

 /**
 * UPDATE LABTESTSAMPLE
 */
export const UPDATE_LABTESTSAMPLE = "UPDATE_LABTESTSAMPLE"
export const UPDATE_LABTESTSAMPLE_STATUS = "UPDATE_LABTESTSAMPLE_STATUS"
export const UPDATE_LABTESTSAMPLE_SUCCESS = "UPDATE_LABTESTSAMPLE_SUCCESS"
export const UPDATE_LABTESTSAMPLE_FAIL = "UPDATE_LABTESTSAMPLE_FAIL"

/**
 * DELETE LABTESTSAMPLE
 */
export const DELETE_LABTESTSAMPLE = "DELETE_LABTESTSAMPLE"
export const DELETE_LABTESTSAMPLE_SUCCESS = "DELETE_LABTESTSAMPLE_SUCCESS"
export const DELETE_LABTESTSAMPLE_FAIL = "DELETE_LABTESTSAMPLE_FAIL"
